import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/roles',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:34
* @route 'https://org.proexpert.app/org/roles'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/roles/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::create
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:85
* @route 'https://org.proexpert.app/org/roles/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
export const show = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/roles/{role}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
show.url = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: args.role,
    }

    return show.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
show.get = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
show.head = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
const showForm = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
showForm.get = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:50
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
showForm.head = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:92
* @route 'https://org.proexpert.app/org/roles'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/roles',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:92
* @route 'https://org.proexpert.app/org/roles'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:92
* @route 'https://org.proexpert.app/org/roles'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:92
* @route 'https://org.proexpert.app/org/roles'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:92
* @route 'https://org.proexpert.app/org/roles'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:119
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
export const update = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/roles/{role}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:119
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
update.url = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: args.role,
    }

    return update.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:119
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
update.put = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:119
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
const updateForm = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::update
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:119
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
updateForm.put = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::destroy
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:151
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
export const destroy = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: 'https://org.proexpert.app/org/roles/{role}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::destroy
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:151
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
destroy.url = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: args.role,
    }

    return destroy.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::destroy
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:151
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
destroy.delete = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::destroy
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:151
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
const destroyForm = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgRoleController::destroy
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgRoleController.php:151
* @route 'https://org.proexpert.app/org/roles/{role}'
*/
destroyForm.delete = (args: { role: string | number } | [role: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const roles = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    show: Object.assign(show, show),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default roles